import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: '1',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // language resources
    resources: {
      '0': {
        translation: {
          "WEBSITE_TITLE": "Jerusky",
          "SLOGAN": "Weather with humor",
          "CURRENT_SIG_WEATHER": "Now",
          "WEATHER_NEARBY": "Weather nearby",
          "STATIONS_NEARBY": "More stations in Jerusalem",
          "HOME_PAGE": "To the home page",
          "MOBILE_FRIENDLY": "Mobile friendly",
          "WHATS_NEW": "What's new",
          "CHOOSE": "Choose month or year",
          "GUESTBOOK": "GuestBook",
          "MODELS": "Models",
          "CONTACT_INFO": "About",
          "LOCATION": "Location",
          "CONTACT_ME": "Contact",
          "START": "Start",
          "LINKS": "Links",
          "AD_LINK": "Ad link to message body",
          "ITALIC": "Italic selected text in message body",
          "LINK": "the link",
          "DICTIONARY": "Dictionary",
          "LINK_TITLE": "link title",
          "GET_UPDATES": "Get alarms by Email",
          "PERSONAL_COLD_METER": "Pesonal Cold Meter",
          "PERSONAL_COLD_METER_ALERT": "You can use personal cold meter by selecting it in your account",
          "UPDATES_INTERVAL": "Updates every INTERVAL min",
          "BANNER_FLASH_VIEW": "Online mode",
          "CELL_VIEW": "Page for cell phone",
          "IPHONE": "Smartphone",
          "WAP_VIEW": "WAP page",
          "TEMP": "temperature",
          "HUMIDITY": "humidity",
          "RAIN": "rain",
          "RAIN_RATE": "Rain rate",
          "PRECIPITATION": "precipitation",
          "BAR": "Pressure",
          "WIND": "wind",
          "SUNSHINEHOURS": "sunshine hours",
          "LOW_RAD": "Turn on the boiler",
          "RADIATION": "radiation",
          "SOLAR_ENERGY": "solar energy",
          "UV": "UV",
          "UV_DOSE": "UV Dose",
          "HIGH_UV": "High and dangerous UV",
          "EXTREME_UV": "Extreme and dangerous UV",
          "SUNSCREEN_UV": "Put sunscreen every 2 hours",
          "ET": "Evapotranspiration",
          "HIGH_ET": "Irrigation needed",
          "KNOTS": "knots",
          "KM": "km",
          "BAR_UNIT": "mb",
          "RAIN_UNIT": "mm",
          "WIND_UNIT": "km\/h",
          "DUST_UNIT": "µg/m3",
          "RAINRATE_UNIT": "mm\/hr",
          "SNOW_UNIT": "cm",
          "KMH": "km\/hr",
          "MINTS": "min",
          "HOUR": "hour",
          "HOURS": "hrs",
          "CLOSE_TO": "close to",
          "SNOW_JER": "Snow in Jerusalem",
          "SNOW_PICTURES": "Snow pictures from that day",
          "SEND_PICTURES": "Send picture",
          "SONGS": "Weather Songs",
          "MYTHS": "Myths",
          "LIGHTS": "Lightning maps",
          "ARCHIVE": "Archive",
          "FORECASTER_JOB": "Forecast job",
          "WIND_CHILL": "wind Chill",
          "IT_FEELS": "feels like",
          "IN_THE_SUN": "sun",
          "THW": "THW",
          "SUMMARY": "Summary",
          "ELEVATION": "Height",
          "METERS": "m",
          "CHANGE_STYLE": "Change style",
          "GOING_DOWN": "going down",
          "GOING_UP": "going up",
          "MORE_INFO": "more",
          "MORE_NOTIFICATIONS": "Notifications archive",
          "MORE_USERS_PICS": "To all users pics",
          "MORE_PIC_OF_THE_DAY": "Pic of the day archive",
          "MORE_LIVE": "more pics from today",
          "WHAT_ELSE": "What's now?",
          "WHAT_MORE": "Notifications",
          "CURRENT_ENERGY": "and what with the energy?",
          "STORM_POWER": "Storm Power",
          "RAIN_RADAR": "Radar",
          "LAST_UPDATE": "updated at",
          "DETAILED_TABLE": "Last day intervaled data",
          "DETAILED_TABLE08": "Last week intervaled data",
          "WIND_DISTRIBUTION": "Hours of wind distribution",
          "CLIMATE": "Climate",
          "CLIMATE_TITLE": "The unique climate of Jerusalem",
          "LOADING": "loading",
          "SHARE": "Share",
          "FAQ": "FAQ",
          "TIPS": "TIPS",
          "TIP": "Tip",
          "PIC_OF_THE_DAY": "Pic of the day",
          "USERS_PICS": "Users Pics",
          "COMMENTS": "Comments",
          "CREATE_NEW_MSG": "New message",
          "LOGIN": "Sign in",
          "SIGN_OUT": "Sign out",
          "REGISTER": "Sign up",
          "FORGOT_PASS": "Reset password",
          "EMAIL": "Email",
          "PASSWORD": "Password",
          "USER_ICON": "Icon",
          "REMEMBER_ME": "Remember me",
          "NEW_PASSWORD": "New password",
          "PASSWORD_VERIFICATION": "Password verification",
          "USER_ID": "User ID",
          "DISPLAY_NAME": "Display name",
          "NICE_NAME": "Nice name",
          "UPDATE_PROFILE": "Update profile",
          "REGISTER_SUGGEST": "If you register (1-2 min issue) you can get your own cold meter suggetions and can view your votes.",
          "ANONYMOUS_COLDMETER": "want to stay anonymous",
          "MY_VOTES": "My Votes",
          "IS_TAKEN": "is taken",
          "USER_LOCKED": "User is locked",
          "DONE": "Done",
          "EMPTY": "empty",
          "IM": "I am",
          "REGISTRATION_TO_02WS": "Registration to 02WS",
          "REGISTRATION_TO_02WS_DONE": "Now enter the credentials in the menu of the app or site.",
          "ADVERTISING": "Ads in Jerusky",
          "SAVE_AS_LAUNCH": "Save it as launch",
          "CURRENT_FIRST": "Current first",
          "NEXTDAYS_FIRST": "next days first",
          "24H_FIRST": "24H first",
          "NOW_DETAILED": "Now detailed",
          "HOURLY": "Hourly",
          "FORECAST_TITLE": "Forecast",
          "FORECAST_4D": "Daily",
          "FORECAST_ABROD": "World Forecast",
          "FORECAST_ISR": "Israel",
          "IN_TABLE": "in table",
          "FORECAST": "Weather Forecast",
          "LIKED_FORECAST": "Liked and disliked forecasts",
          "WORLD": "World",
          "ISRAEL": "Israel",
          "FORECAST_TEMP": "Which temp is expected at ",
          "THUNDERSTORM": "thunderstorm",
          "LIGHT_RAIN": "light rain",
          "HEAVY_RAIN": "heavy rain",
          "LIGHT_SNOW": "light snow",
          "LOCAL_RAIN": "local rain",
          "FEW_SHOWERS": "few showers",
          "SINGLE_SHOWER": "single shower",
          "HERE_AND_THERE_RAIN": "here and there rain",
          "THUNDERSTORM_RAIN": "Thunder and rain and hail",
          "DRIZZLE": "drizzle",
          "SNOW": "snow",
          "SLEET": "sleet",
          "HAIL": "hail",
          "FOG": "fog",
          "SANDSTORM": "sandstorm",
          "WARM_WIND": "warm wind",
          "SEVERE_CLOUDS": "heavy clouds",
          "DUST": "dust",
          "DUSTPM25": "small ",
          "DUSTPM10": "large",
          "DUST_THRESHOLD0": "healthy",
          "DUST_THRESHOLD1": "Not healthy",
          "DUST_THRESHOLD2": "Sport activity is not recommended",
          "DUST_THRESHOLD3": "small is more dangerous",
          "SPORT_FORBIDEN": "You should hold your outside activity",
          "ALERGY": "allergy",
          "TEMPO": "temporarily",
          "CLOUDY": "cloudy",
          "MOSTLY": "mostly",
          "PARTLY": "partly",
          "PARTLY_CLOUDY": "partly cloudy",
          "MOSTLY_CLOUDY": "mostly cloudy",
          "FEW_CLOUDS": "few clouds",
          "LOW_CLOUDS": "low clouds",
          "MEDIUM_HIGH_CLOUDS": "Medium and high clouds",
          "HIGH_CLOUDS": "High clouds",
          "CLEAR": "clear",
          "HAZE": "haze",
          "MIST_AT_NIGHT": "mist at night",
          "PROB": "probably",
          "AND": "and",
          "NIGHT": "night",
          "AFTERNOON": "afternoon",
          "NOON": "noon",
          "MORNING": "morning",
          "EARLY_MORNING": "morning",
          "EVENING": "evening",
          "DURING": "during",
          "THE": "the",
          "OR": "or",
          "GENERALLY": "Generally",
          "CHANCE_FOR": "chance of ",
          "GOOD_CHANCE_FOR": "good chance of ",
          "LOW_CHANCE_FOR": "low chance of ",
          "ISOLATED": "isolated",
          "OCCASIONALLY": "occasionally",
          "AT_TIMES": "at times",
          "ALTERNATELY": "alternately",
          "RAINY": "rainy",
          "EXTREME_WINDS": "Extreme wind",
          "STRONG_WINDS": "Strong wind",
          "MODERATE_WINDS": "Moderate wind",
          "WEAK_WINDS": "Light wind",
          "EXTREME_WINDS_DESC": "Sudden side wind, hard to walk in the street",
          "STRONG_WINDS_DESC": "Not comfortable, could blow out some light stuff or laundry",
          "MODERATE_WINDS_DESC": "might be interrupting in some situations",
          "WEAK_WINDS_DESC": "refreshing in the sun, chilly in the night",
          "BECMG": "becoming",
          "BECMG_TO": "to",
          "FROM": "from ",
          "TO": "to",
          "GIVEN": "given",
          "AT": "at ",
          "LIKE": "like",
          "DISLIKE": "dislike ",
          "CHANCE_OF": "chance of",
          "LATER": "later",
          "AT_FIRST": "at first",
          "VERY": "very",
          "OVERLOOK": "Outlook",
          "OVERLOOK_EXP": "The forecast might change in a higher chance than previous days",
          "NIGHT_TEMP_EXP": "Evening = 20:00 to 24:00. Low temp occurs usually (but not always) in the early morning of the same day",
          "WHAT_IS_FORECAST": "What is weather forecast?",
          "FORECAST_DESC": "This forecast is for Jerusalem. For other location nearby you have to increase 0.8 degreee for every 100m decrease in elevation.",
          "WHICH_IS": "which is",
          "YESTERDAY": "yesterday",
          "TOMORROW": "tomorrow",
          "TODAY": "today",
          "NOW": "Now",
          "CHANGE": "change in ",
          "MAX": "Max",
          "MIN": "Minimum",
          "MID": "Mid",
          "SPECIAL_NOTICE": "Special notice",
          "PRINT": "Print this page",
          "BACK": "Back",
          "CLOUD_BASE": "Cloud base",
          "MOON_PHASE": "Moon phase",
          "SUN_PHASE": "Sun",
          "WHOLE_SEASON": "Whole Season",
          "TILL_NOW": "till now",
          "DIFF_FROM": "compared to",
          "NORMAL": "normal",
          "DAYS": "days",
          "RAINY_DAYS": "rainy days",
          "GLOBAL_WARMING": "Warming since 2001",
          "DAILY_LOOP": "All-day pictures in a clip",
          "DAILY_LOOP_ARCHIVE": "How the day was - by date",
          "BY_DATE": "by date",
          "SATELLITE": "Satellite",
          "PICTURES": "Album",
          "DID_YOU_KNOW": "Did you know?",
          "ALBUM_DESC": "Pictures of nature, seasons, snow and more...",
          "WINTER": "Winter",
          "AUTOMN": "Autumn",
          "SPRING": "Spring",
          "SUMMER": "Summer",
          "MOBILE_REDIRECT": "Redirect to mobile page",
          "DESKTOP_REDIRECT": "Redirect to site",
          "STAY": "Stay in site",
          "RUNNING_TREKS": "Running treks",
          "FSEASON": "what is your favorite season?",
          "LIVE_PICTURE": "Live Air",
          "PIC_DESC": "2 cameras and animation of latest frames",
          "LIVE_STREAM": "Live Stream",
          "CAMERA": "Camera",
          "CAMERA_LOOP": "latest pictures in a loop",
          "TRENDS": "Trends",
          "DAYS_WITHOUT_RAIN": "days without rain",
          "LEFTOVER": "leftover of",
          "LACK": "missing out",
          "COLD_METER": "not agree? vote!",
          "COLD_METER_YES": "Yes! I agree!",
          "WEATHER_CLIPS": "Weather clips",
          "ROAD": "at road",
          "ROAD_EXP": "The thermometer is on stone. Asphalt could be hotter in the sun.",
          "ROAD_EXP_NIGHT": "At night it is like the temp in valleys",
          "DEW_DESC": "18 - sauna level 1, 20 - sauna level 2, 22 - sauna level 3",
          "VALLEY": "at valley",
          "LOW_VALLEY": "at lowest places",
          "MOUNTAIN": "at hill",
          "NOT_MOUNTAIN": "not at hill",
          "MOUNTAIN_VALLEY_DIF": "Diff between mountain and valley",
          "DETAILED_BY_DAY": "detailed by day",
          "EXTREME_HEAT_INDEX": "Extreme Heat Index",
          "HEAVY_HEAT_INDEX": "Heavy Heat Index",
          "MEDIUM_HEAT_INDEX": "Medium Heat Index",
          "LOW_HEAT_INDEX": "Low Heat Index",
          "VVHOT": "Hot as hell",
          "VHOT": "Very hot, not extreme",
          "HOT": "Hot enough for shorts",
          "LHOT": "Hot enough for T-shirt",
          "NHOTNCOLD": "Neither hot nor cold",
          "COLDISH": "Cool, light jacket",
          "LCOLD": "Chilly",
          "COLD": "Cold (coat)",
          "VCOLD": "Very cold (gloves etc)",
          "VVCOLD": "Extremely cold",
          "HOT_GROUND": "Hot ground",
          "GENDER": "Gender",
          "MALE": "Male",
          "FEMALE": "Female",
          "NOR_MALE_NOR_FEMALE": "no male nor female",
          "GENDER_NOTICE": "The cold estimator is evaluated from you being",
          "GENDER_NOTICE2": "To alter this assumption go to vote again.",
          "SHORTS": "Shorts. Short pants and t-shirt.",
          "TSHIRT": "T-shirt",
          "LONGSLEEVES": "long sleeves, it is recommended to take also t-shirt and add or remove layer when necessary",
          "SUN_SHADE_CLOTH": "short in the sun, long in the shade",
          "SUN_SHADE_JACKET": "open in the sun, closed in the shade",
          "SWEATSHIRT": "Sweatshirt",
          "SWEATER": "Sweater or something warm",
          "JACKET": "Jacket or fleese",
          "COAT": "Coat",
          "RAINCOAT": "Rain coat",
          "LIGHTCOAT": "light coat",
          "LIGHTJACKET": "light jacket",
          "LAYERS_BELOW": "1 layer beneath",
          "LAYERS_BELOW2": "2 layers beneath",
          "LAYERS_BELOW3": "3 layers beneath, scarf and warm hat",
          "LAYERS_BELOW3_PLUS": "3 layers beneath, scarf and warm hat, long underwear, thermal clothing",
          "UMBRELLA": "Umbrella",
          "NOTHING_SPECIAL": "Nothing Special",
          "HIGH_DEW_OVER_NIGHT": "High dew over night - wet grass",
          "RAIN_WILL_STOP": "Rain will stop",
          "MORE_CLOUDS": "Much more clouds",
          "RAIN_HAS_JUST_STOPPED": "Break in rain",
          "RAIN_HAS_GONE": "Break in rain",
          "ITS_RAINING": "Its raining",
          "STORMY": "Stormy",
          "ITS_SNOWING": "Its snowing",
          "RAIN_PROB_EXP_TITLE": "chances explanation",
          "RAIN_PROB_EXP": "low chance (30%) - keep your event outise alive, but consider a\r\nsituation of rain (plan B).\r\ngood chance (60%) - fits event which is not deliacate to rain and short breaks can be done\r\nunder hood.\r\nhigh chance (80%) - does not fit for continues acticity outside. But, what is the probelm with rain\r\ncoat?",
          "RAIN_LOW_EXP": "low chance (30%) - keep your event outise alive, but consider a\r\nsituation of rain (plan B).\r\n",
          "RAIN_GOOD_EXP": "good chance (60%) - fits event which is not deliacate to rain and short breaks can be done\r\nunder hood.",
          "RAIN_HIGH_EXP": "high chance (80%) - does not fit for continues acticity outside. But, what is the probelm with rain\r\ncoat?",
          "PRESSURE_IS_FALLING": "Pressure's falling",
          "DRASTIC_TEMP_DROP": "Temp drop",
          "DRASTIC_PRESSURE_RISE": "Pressure rise",
          "DRASTIC_TEMP_RISE": "Temp rise",
          "DRASTIC_WIND_RISE": "Wind rise",
          "VERY_DRY": "Very dry",
          "DRASTIC_HUM_RISE": "Humidity rise",
          "DRASTIC_HUM_DROP": "Humidity drop",
          "HIGH_DUST": "Air is dusty",
          "WINDY": "Windy",
          "WIND_GUST": "Gust",
          "WIND_SHIFT": "Wind shift",
          "NO_WIND": "the air stands still",
          "WITHOUT_WIND": "Without Wind",
          "LIGHT_WIND": "Light Wind",
          "MODERATE_WIND": "Moderate Wind",
          "VERY_HOT_HEAT_WAVE": "Hot and Dry",
          "WARMER_THAN_AVERAGE": "above average",
          "COLDER_THAN_AVERAGE": "below average",
          "HIGH_HUMIDITY": "High humidity in sports",
          "SAUNA1": "Sauna level 1",
          "SAUNA2": "Sauna level 2",
          "SAUNA3": "Sauna level 3",
          "LIKE_AVERAGE": "like average",
          "THERE_IS": "there's",
          "RAIN_SITUATION": "rainfall situation",
          "YOU_BETTER": "You had better",
          "CLOSE": "close",
          "OPEN": "open",
          "THE_WINDOW": "the window",
          "OUTSIDE": "outside",
          "INSIDE": "inside",
          "VERY_COLD": "very cold",
          "COLD_SUN": "Cold sun",
          "HALF_COLD_SUN": "Half cold sun",
          "SHADE": "shade",
          "SUN_SHADE": "Warm in sun, cold in shade",
          "GOOD_TIME": [
              "Good time to stay outside",
              " Nice for picnic"
          ],
          "GOOD_TIME_FOR": "good time for",
          "NOT_GOOD_TIME_FOR": "not good for",
          "GOOD_DAY_FOR": "good day for",
          "GOOD_LAUNDRY": "Good time to dry laundry",
          "SOSO_LAUNDRY": "Not Ideal time to dry laundry, but acceptable",
          "BAD_LAUNDRY": "Bad time to dry laundry - because of rain or dust or humidity",
          "IN": "in",
          "REMOVE_LAUNDRY": "remove laundry",
          "PIVOT_DESC": "Assuming idealistic inside temperature of: ",
          "RECORDS_LINK": "When there was 1134 mm rainfall? look here",
          "YEARLY_SUMMARY_LINK": "Yearly summary",
          "MONTHLY_SUMMARY_LINK": "Monthly summary",
          "KINNERET": "Kinneret Lake",
          "NEW": "New",
          "LAST_RECORD": "last record",
          "ON": "at",
          "YEARLY": "yearly",
          "BROKEN": "has been broken",
          "RECORD": "Record",
          "RECORDS": "Records",
          "REPORTS": "Reports",
          "HIGH": "Hi",
          "LOW": "Lo",
          "AVERAGE": "Average",
          "YEARLY_AVERAGE": "Yearly average",
          "MONTH": "month",
          "YEAR": "year",
          "MONTHS": "months",
          "MONTHLY": "monthly",
          "DAY": "Day",
          "HOURLY": "Hourly",
          "DAILY_RAIN": "Daily rain",
          "STORM_RAIN": "Storm rain",
          "TOTAL_RAIN": "Total",
          "MONTHLY_RAIN": "Monthly rain",
          "SHOW": "Show",
          "SEND": "Send",
          "CANCEL": "Cancel",
          "MORE_INFO_SPAN": "extend",
          "ALL_GRAPHS": "all graphs",
          "MORE_THAN": "more than",
          "LESS_THAN": "less than",
          "GRAPH": "graph",
          "FOR": "for",
          "WEEKS": "Weeks",
          "HISTORY": "History",
          "WHAT_HAPPEND": "History",
          "HAPPENING": "Current",
          "WILL_HAPPEN": "Forecast",
          "MY": "My 02WS",
          "GENERAL": "General",
          "CURRENT_INSTABLITY": "Current Instability",
          "MEDIUM": "Medium",
          "EXTREME": "Extreme",
          "WEAK": "Weak",
          "STRONG": "Strong",
          "INVERSION": "Inversion",
          "RADIOSONDE": "Radiosonde",
          "FIRE_INDEX": "High risk in fire starting",
          "DELTA": "delta",
          "THICKNESS": "thickness",
          "BASE": "base",
          "LEGEND": "legend",
          "SOURCE": "Source",
          "IMS": "The Israeli Meteorological Service",
          "MY_STATION": "My station",
          "RAIN_SEASONS": "Rain seasons",
          "RAINRATE": "Rain rate",
          "DEW": "Dew Point",
          "THSW": "THSW",
          "AIR_DENSITY": "Air Density",
          "AIR_QUALITY": "Air pollution level?",
          "HEAT_IDX": "Heat Index",
          "WIND_SPEED": "Wind Speed",
          "WIND_DIR": "Wind Direction",
          "WIND_HIGH": "High Wind",
          "WIND_HIGH_DIR": "High Wind Direction",
          "WIND_RUN": "Wind Run",
          "FULL": "Full",
          "NEW_MOON": "New moon",
          "FULL_MOON": "Full moon",
          "MOON": "Moon",
          "RISE": "Rise",
          "SET": "Set",
          "SEARCH_IN": "Search",
          "BETWEEN": "Between",
          "CHAT_TITLE": "Forum",
          "SYNOP_TITLE": "Synoptic chart",
          "MESSAGES": "Messages",
          "CURRENT_STORY": "Current story",
          "PRIVATE_MSG": "Private message",
          "PRIVATE_MSG_TO_SENDER": "Private message to the opener",
          "ALERT_MSG_TO_SENDER": "Get alert when replied",
          "MANAGER": "02WS Manager",
          "V_MANAGER": "Vice Manager",
          "NAME": "Name",
          "BODY": "message",
          "WATCH": "Watch ",
          "REPLY": "Reply",
          "REPLYES": "Replies",
          "NEED_TO_REGISTER": "need to login\/register",
          "ALERTS_PAYMENT_FULL": "shortTo get this before everyone click here<\/a><\/div>",
          "ALERTS_TO_APP_PROMO": "That info you can get before everyone else in a push message in the app.",
          "ALERTS_PAYMENT": "<div class=\"alertspayment\"><a href=\"#opensettings.png\"><img src=\"images\/opensettings.png\" alt=\"short term alerts\" width=\"18\" \/><\/a><\/div>",
          "SHORT_TERM_DESC": "Put this code in the setting menu of the app to get short term alerts from 02ws: ",
          "SHORT_TERM_TITLE": "02WS Short term alerts subscription",
          "PATREON_LINK": "<a href=\"https:\/\/www.patreon.com\/bePatron?c=1347814&rid=2162701\" target=\"_blank\">here<\/a>",
          "REPLY_EXP": "click here and then on send",
          "REPLY_ENGAGE": "Use the reply for feedback about the alert or whatever",
          "FILTERRING_BY_SUBJECT": "Filtering by subject",
          "MSG_SUBJECT": "Message subject",
          "LAST_MSG": "recent",
          "LAST_DAY": "last day",
          "LAST_WEEK": "last week",
          "LAST_MONTH": "last month",
          "WATCH_ALL": "Watch all messages",
          "MAN_EXP": "",
          "CHECK_EMAIL": "Check your Email to make your user active. If you so not seeanything, check tha spam",
          "USER_ID_EXP": "User ID (optionally with numbers in it)",
          "DISPLAY_NAME_EXP": "The name in the forum",
          "NICENAME_EXP": "The name in the mailing list and in the forum title",
          "PERSONAL_COLD_METER_EXP": "The cold meter will be displayed based on your votes only",
          "HELLO": "Hello",
          "HOTORCOLD_Q": "How do you feel now with the current temp in the shade?",
          "HOTORCOLD_T": "Cold meter",
          "FSEASON_T": "Best season",
          "ONLYONEVOTE": "Not enough time has passed since the last vote",
          "TOTAL_VOTERS": "Total voters",
          "TOTAL_VOTERS_FEMALE": "Total voters",
          "MOST_POPULAR": "Most popular",
          "HAPPY": "Happy",
          "ANGRY": "Angry",
          "TIRE": "Tire",
          "EMBARRASED": "Embarrased",
          "SAD": "Sad",
          "SATISFIED": "Satisfied",
          "IMHOT": "I'm hot",
          "IMCOLD": "I'm cold",
          "DOUBT": "skeptic",
          "WINK": "wink",
          "AMAZED": "Amazed",
          "CONFUSE": "Confused",
          "KISS": "Kiss",
          "COOL": "Cool",
          "CURIOUS": "Curious",
          "DIGGING": "Digging",
          "PUDENCY": "Pudency",
          "HELL": "Who can beat me",
          "RUN_WALK": "Run and walk",
          "HUM_LOW": "Low humidity",
          "HUM_HIGH": "High Humidity",
          "HUM_NEUTRAL": "Neutral humidity",
          "RUN_GENERAL_EXP": "",
          "WIND_HUM_EXP": "Wind cause chill, humidity makes us feel warmer.",
          "SUN_EXP": "Staying in the sun always warms up. Sometimes it is only a couple of degrees, sometimes it is even more than 10 degrees.",
          "HIGH_WIND_HIGH_TEMP_EXP": "Wind chills the hot sun",
          "HIGH_WIND_EXP": "High wind - take another layer",
          "LIGHT_WIND_NIGHT_EXP": "Wind gives cooler feeling",
          "NO_WIND_LOW_TEMP_EXP": "No wind - good conditions",
          "HIGH_HUM_EXP": "Humidity gives warmer feeling, sweating more",
          "LOW_HUM_LOW_TEMP_EXP": "Humidity gives chilly feeling, maybe add layer.",
          "LOW_HUM_HIGH_TEMP_EXP": "Low humidity, classic, drink more.",
          "SUN_SHADE_DIFF_EXP": "Much hotter in the sun",
          "DID_YOU_KNOW_EX": [
              "Personal cold meter. If you will register and vote and check it in your account, you will get your votes instead of the general public votes of the cold meter.",
              "The lowest temperature in a day is mostly before sunrise. That is correct if the sky is clear and almost without wind.",
              " The highest layer of snow in Jerusalem was 98cm",
              "You can feel different, depending on sun, wind, humidity, location. So, it is advised to take into account all of those parameters by looking into the `feels like` and locations like mountain and valley."
          ],
          "DID_YOU_KNOW_SUMMER": [
              "The highest record temperature in Jerusalem is 44C and it happended on August 1881",
              "Personal cold meter. If you will register and vote and check it in your account, you will get your votes instead of the general public votes of the cold meter.",
              "Before going out think which type of activity you will do. If it is active one it is advised to remove layer.",
              "Humidity warms, wind chills. Wind in the valleys tend to be less than in the exposed to west locations."
          ],
          "DUST_EXISTS_IN24HF": [
              "Dust is expected, be aware",
              "Clean air will be replaced with dust",
              "The horizon is not clean, dust is coming"
          ],
          "RAIN_EXISTS_IN24HF": [
              "Rain is expected, be aware and plan",
              "Here comes the rain again",
              "Blue sky, when you gonna learn to rain? soon"
          ],
          "HIGHWIND_EXISTS_IN24HF": [
              "High wind is expected later on",
              "Trees will feel the wind strength",
              "The windmill will fulill its destiny"
          ],
          "END": "Ok",
          "CLICK_TO_CONFIRM": "Click here to confirm your registration to 02ws.co.il and make your user active",
          "CLICK_TO_RESET": "Click here to reset your password",
          "CHECK_EMAIL_RESET_PASS": "Go to your email for password reset",
          "PROBLEM_USER_PASSWORD": "Problem with user or password",
          "NO_USER_EXIST": "No user exists like that",
          "VISIBILITY": "visibility",
          "SUNRISE": "Sunrise",
          "SUNSET": "Sunset",
          "CLOTH": "cloth",
          "LAYOUT": "Layout",
          "SNOW_POEMS": "snow poems",
          "VOTE_INSERTED": "Your vote inserted to overall calculations. You have joined to thousend of voters, thank you!"
      }
      },
      '1': {
        translation: {
          "WEBSITE_TITLE": "ירושמיים",
          "SLOGAN": "מזג-אוויר עם קור-טוב של הומור",
          "CURRENT_SIG_WEATHER": "מה עכשיו",
          "WEATHER_NEARBY": "מה קורה באזור?",
          "STATIONS_NEARBY": "עוד תחנות בי-ם",
          "HOME_PAGE": "לעמוד הראשי",
          "MOBILE_FRIENDLY": "מותאם לנייד",
          "WHATS_NEW": "מה חדש",
          "CHOOSE": "בחר חודש או שנה",
          "GUESTBOOK": "ספר אורחים",
          "MODELS": "מודלים",
          "CONTACT_INFO": "אודות",
          "LOCATION": "מיקום",
          "CONTACT_ME": "צרו קשר",
          "START": "התחל",
          "LINKS": "קישורים",
          "AD_LINK": "הוספת קישור לגוף ההודעה",
          "ITALIC": "הדגשה של טקסט מסומן בגוף ההודעה",
          "LINK": "הקישור",
          "DICTIONARY": "מונחון",
          "LINK_TITLE": "כותרת לקישור",
          "GET_UPDATES": "קבלו התראות באימייל",
          "PERSONAL_COLD_METER": "מדד קור מותאם אישית",
          "PERSONAL_COLD_METER_ALERT": "מדד קור מותאם אישית לפי ההצבעות שלכם אפשרי תחת פרופיל החשבון שלכם.",
          "UPDATES_INTERVAL": " מתעדכן כל INTERVAL דקות",
          "BANNER_FLASH_VIEW": "מצב אונליין",
          "CELL_VIEW": "דף לפלאפון",
          "IPHONE": "סמארטפון",
          "WAP_VIEW": "WAP",
          "TEMP": "טמפרטורה",
          "HUMIDITY": "לחות",
          "RAIN": "גשם",
          "RAIN_RATE": "עוצמת גשם",
          "PRECIPITATION": "משקעים",
          "BAR": "לחץ-אוויר",
          "WIND": "רוח",
          "SUNSHINEHOURS": "שעות שמש",
          "LOW_RAD": "כדאי להדליק את הבוילר - השמש לא סיפקה את הסחורה ",
          "RADIATION": "קרינה",
          "SOLAR_ENERGY": "אנרגיה סולרית",
          "UV": "UV",
          "UV_DOSE": "UV מנות",
          "HIGH_UV": "קרינה מסוכנת",
          "EXTREME_UV": "קרינה קיצונית",
          "SUNSCREEN_UV": "שימו קרם הגנה כל שעתיים",
          "ET": "אידוי",
          "HIGH_ET": "הצמחים צמאים",
          "KNOTS": "קשר",
          "KM": "קמ",
          "BAR_UNIT": "מב",
          "RAIN_UNIT": "ממ",
          "WIND_UNIT": "קמש",
          "DUST_UNIT": "מ''ג",
          "RAINRATE_UNIT": "ממ לשעה",
          "SNOW_UNIT": "סמ",
          "KMH": "קמש",
          "MINTS": "דק'",
          "HOUR": "שעה",
          "HOURS": "שע'",
          "CLOSE_TO": "קרוב ל-",
          "SNOW_JER": "שלג בירושלים",
          "SNOW_PICTURES": "תמונות שלג מהאירוע",
          "SEND_PICTURES": "שליחת תמונה",
          "SONGS": "שירי מזג-אוויר",
          "MYTHS": "מיתוסים",
          "LIGHTS": "מפות ברקים",
          "ARCHIVE": "ארכיון",
          "FORECASTER_JOB": "יום בחיי חזאי",
          "WIND_CHILL": "אפקט קרור הרוח",
          "IT_FEELS": "מרגיש כמו",
          "IN_THE_SUN": "בשמש",
          "THW": "שקלול הרוח והלחות",
          "SUMMARY": "סיכום",
          "ELEVATION": "גובה",
          "METERS": "מ'",
          "CHANGE_STYLE": "שנה עיצוב",
          "GOING_DOWN": "במגמת ירידה",
          "GOING_UP": "במגמת עליה",
          "MORE_INFO": "עוד",
          "MORE_NOTIFICATIONS": " לכל העדכונים הנוסטלגיים",
          "MORE_USERS_PICS": "לכל תמונות הגולשים",
          "MORE_PIC_OF_THE_DAY": "אוסף תמונות היום",
          "MORE_LIVE": "עוד תמונות מהיום",
          "WHAT_ELSE": "מה עוד קורה עכשיו",
          "WHAT_MORE": "התראות",
          "CURRENT_ENERGY": "נו, ומה עם האנרגיה?",
          "STORM_POWER": "מדדי חוזק המערכת",
          "RAIN_RADAR": "מכ''ם גשם",
          "LAST_UPDATE": "עדכון אחרון: ",
          "DETAILED_TABLE": "יום-יומיים אחרונים בטבלה",
          "DETAILED_TABLE08": "שבוע אחרון בטבלה",
          "WIND_DISTRIBUTION": "התפלגות הרוח על פני שעות אחרונות",
          "CLIMATE": "אקלים",
          "CLIMATE_TITLE": "האקלים הייחודי של ירושלים",
          "LOADING": "טוען",
          "SHARE": "שיתוף",
          "FAQ": "שאלות ותשובות",
          "TIPS": "טיפים",
          "TIP": "טיפ",
          "PIC_OF_THE_DAY": "תמונת היום",
          "USERS_PICS": "תמונות הגולשים",
          "COMMENTS": "הערות",
          "CREATE_NEW_MSG": "הודעה חדשה",
          "LOGIN": "כניסה",
          "SIGN_OUT": "התנתקות",
          "REGISTER": "הרשמה",
          "FORGOT_PASS": "שכחתי סיסמה",
          "EMAIL": "אימייל",
          "PASSWORD": "סיסמה",
          "USER_ICON": "אייקון",
          "REMEMBER_ME": "זכור אותי",
          "NEW_PASSWORD": "סיסמא חדשה",
          "PASSWORD_VERIFICATION": "אימות סיסמה",
          "USER_ID": "שם משתמש",
          "DISPLAY_NAME": "שם לתצוגה",
          "NICE_NAME": "שם רשמי",
          "UPDATE_PROFILE": "עדכון חשבון",
          "REGISTER_SUGGEST": ".אם תרשמו (עניין של דקה-שתיים) תוכלו לקבל גם מדד\r\nקור מותאם להצבעתכם האישית ותוכלו גם לצפות בכל ההצבעות ",
          "ANONYMOUS_COLDMETER": "לא רוצה להישאל שוב",
          "MY_VOTES": "ההצבעות שלי",
          "IS_TAKEN": "תפוס",
          "USER_LOCKED": "חשבון חסום",
          "DONE": "בוצע",
          "EMPTY": "ריק",
          "IM": "אני",
          "REGISTRATION_TO_02WS": "הרשמה לאתר ירושמיים",
          "REGISTRATION_TO_02WS_DONE": "כעת הכניסו את שם המשתמש והססמה בתפריט כדי להיכנס",
          "ADVERTISING": "פרסום בירושמיים",
          "SAVE_AS_LAUNCH": "שמירה כדף פתיחה",
          "CURRENT_FIRST": "מה עכשיו ראשון",
          "NEXTDAYS_FIRST": "יומי ראשון",
          "24H_FIRST": "שעתי ראשון",
          "NOW_DETAILED": "מה עכשיו מפורט",
          "HOURLY": "שעתי",
          "FORECAST_TITLE": "תחזית",
          "FORECAST_4D": "יומי",
          "FORECAST_ABROD": "תחזית לחו''ל - ארה''ב, אירופה, אמריקה ועוד",
          "FORECAST_ISR": "תחזית לארץ",
          "IN_TABLE": "בטבלה",
          "FORECAST": "מזג-אוויר חזוי",
          "LIKED_FORECAST": "תחזיות אהובות",
          "WORLD": "תחזית לחו''ל",
          "ISRAEL": "לארץ",
          "FORECAST_TEMP": "איזו טמפרטורה צפויה בשעה",
          "THUNDERSTORM": "סופת רעמים",
          "LIGHT_RAIN": "גשם קל",
          "HEAVY_RAIN": "גשם כבד",
          "LIGHT_SNOW": "שלג קל",
          "LOCAL_RAIN": "גשם מקומי",
          "FEW_SHOWERS": "גשמים יחידים",
          "SINGLE_SHOWER": "גשם חולף",
          "HERE_AND_THERE_RAIN": "גשם פה ושם",
          "THUNDERSTORM_RAIN": "גשם עם רעמים וברד",
          "DRIZZLE": "טפטוף",
          "SNOW": "שלג",
          "SNOWRAIN": "גשם מעורב בשלג",
          "SLEET": "סליט",
          "HAIL": "ברד",
          "FOG": "ערפילי",
          "SANDSTORM": "סופת חול",
          "WARM_WIND": "רוח חמה",
          "SEVERE_CLOUDS": "עננים כבדים",
          "DUST": "אבק",
          "DUSTPM25": "אבק קטן",
          "DUSTPM10": "אבק גדול",
          "DUST_THRESHOLD0": "תקין",
          "DUST_THRESHOLD1": "לא תקין",
          "DUST_THRESHOLD2": "לצמצם פעילות בחוץ",
          "DUST_THRESHOLD3": "הקטן יותר מסוכן",
          "SPORT_FORBIDEN": "צריך לצמצם פעילות בחוץ",
          "ALERGY": "אלרגיה",
          "TEMPO": "זמנית",
          "CLOUDY": "מעונן",
          "MOSTLY": "בד''כ",
          "PARTLY": "חלקית",
          "PARTLY_CLOUDY": "מעונן חלקית",
          "MOSTLY_CLOUDY": "בד``כ מעונן",
          "FEW_CLOUDS": "כמה עננים",
          "LOW_CLOUDS": "עננים נמוכים",
          "MEDIUM_HIGH_CLOUDS": "עננים בינוניים וגבוהים",
          "HIGH_CLOUDS": "ענני נוצה - עננים גבוהים",
          "CLEAR": "בהיר",
          "HAZE": "מעט אביך",
          "MIST_AT_NIGHT": "ערפילי בלילה",
          "PROB": "יתכן",
          "AND": "ו",
          "NIGHT": "לילה",
          "AFTERNOON": "אחה''צ",
          "NOON": "צהריים",
          "MORNING": "בוקר",
          "EARLY_MORNING": "לפנות בוקר",
          "EVENING": "ערב",
          "DURING": "במהלך",
          "THE": "ה ",
          "OR": "או",
          "GENERALLY": "באופן כללי",
          "CHANCE_FOR": "יתכן",
          "GOOD_CHANCE_FOR": "סיכוי טוב ל",
          "LOW_CHANCE_FOR": "סיכוי נמוך ל",
          "ISOLATED": "יחיד",
          "OCCASIONALLY": "מדי פעם",
          "AT_TIMES": "לפרקים",
          "ALTERNATELY": "לסירוגין",
          "RAINY": "גשום",
          "EXTREME_WINDS": "רוח סערה",
          "STRONG_WINDS": "רוח חזקה",
          "MODERATE_WINDS": "רוח ערה",
          "WEAK_WINDS": "רוח קלה",
          "EXTREME_WINDS_DESC": "רוחות צד פתאומיות, קשה ללכת ברחוב",
          "STRONG_WINDS_DESC": "מצב לא נוח, יכולה להעיף כביסה או חפצים קלים",
          "MODERATE_WINDS_DESC": "מורגש, יכול להפריע במצבים מסוימים, אבל העורבים לא עוזבים את צמרות העצים",
          "WEAK_WINDS_DESC": "מרענן בשמש, מקרר בצל ובלילה",
          "BECMG": "ישתנה",
          "BECMG_TO": "ל",
          "FROM": "מ",
          "TO": "עד",
          "GIVEN": "ניתנה",
          "AT": "ב-",
          "LIKE": "אהבתי",
          "DISLIKE": "לא אהבתי",
          "CHANCE_OF": "סיכוי ל",
          "LATER": "לקראת סוף היום",
          "AT_FIRST": "בבוקר",
          "VERY": " מאד ",
          "OVERLOOK": "תשקיף",
          "OVERLOOK_EXP": "התחזית עשויה להשתנות בסיכוי גבוה יותר מאשר ימים קודמים",
          "NIGHT_TEMP_EXP": "השעות 20:00 עד 23:00. מינימום מתרחש בד''כ בשעות של לפנות בוקר. את המינימום של אותו לילה תמצאו למחרת",
          "WHAT_IS_FORECAST": "מה זאת תחזית?",
          "FORECAST_DESC": "זאת תחזית עבור ירושלים. אם מחפשים יעד קרוב בגובה אחר - צריך להעלות 0.8 מעלות לכל 100 מ' ירידה בגובה.הזמנים המוזכרים עבור התחזית ל-24 שעות הינם בגדר הערכות ולא מתיימרים לציין זמן מדוייק. כלומר זה יותר בגדר 'ערב', 'בוקר' או 'לילה'.  מה זאת תחזית? עד כמה אפשר לדייק בתחזית? אלה שאלות רלוונטיות שלרוב לא מתייחסים להן בכלל.  אנשים רוצים לדעת אם יירד גשם בשעה 12:35 על עץ התות בחצר תיאטרון החאן. זאת בקשה לא אפשרית כי תחזית אפשר לתת לאיזור ולטווח של שעות, לא לשעה ספציפית ולא למקום ספציפי. זהו פער (בין הרצוי למצוי) שתמיד קיים ותמיד יתקיים בעתיד הנראה לעין, בגלל הצורה שבה תחזית נוצרת.  תחזית נוצרת מתנאי התחלה הנלקחים מבלונים המופרחים לאוויר בנקודות מדגמיות בעולם, הלא הן הרדיוסונדות. בארץ יש רק מקום אחד שממנו מופרח בלון כזה. משום שזה מדגמי ובגלל הסיבוכיות של האטמוספירה, אפשר לחזות  רק ל-4-5 ימים בדיוק לא רע עבור אזורים ולתת תשקיף לשבוע מראש. לא עבור נקודות על המפה.  אבל כאן אנחנו מדברים על תחזית לנקודה ספציפית - ירושלים. לכן כבר מעצם הגדרת התחזית יש כאן כשל. כשל שיכול לגרום לאי דיוק, לכאורה, בתחזית. תחזית למיקום ספציפי רגישה הרבה יותר לשינויים קלים במיקומי מערכות. שקע זז כמה קמ ויש לכך השפעה מקצה לקצה בירושלים. כאן באתר יש ניסיון לתת ניואנסים בתחזית שיתאימו לאיזור ירושלים, דבר שלא קיים בתחזיות הכלליות שניתנות במקומות אחרים.  בחורה הולכת במדרכה יבשה בתלפיות, כאשר בגבעה הצרפתית הכל רטוב והיא תגיד לעצמה : 'איפה הגשם?'  כלבלב ילך להשתין להנאתו בגן סאקר ויתפלא שלא יורד גשם, כאשר חברו בתלפיות יעשה סקי מים בשלוליות שליד ביתו.  תחזית שמנבאת גשם שיורד לבסוף ברמאללה ולא דרומה מכך היא עדיין תחזית שהצליחה, מכיוון  שמדובר באותו איזור ההר המרכזי. צריך להכיר במגבלות התחזית.  יש גם את האנשים שקמים בבוקר אחרי לילה גשום אל תוך יום יבש וישר חושבים שהתחזית נכשלה. גם גשם בלילה הוא גשם. לילה הוא חלק  מהיממה.  אחרי שנאמרו כל הדברים, קורה גם שהתחזית נכשלת וכן, זה מבאס. אבל, הכל בא מתוך רצון  לתת שירות שלא קיים ברשת. אז תיהנו!",
          "WHICH_IS": "שזה",
          "YESTERDAY": "אתמול",
          "TOMORROW": "למחרת",
          "TODAY": "היום",
          "NOW": "עכשיו",
          "CHANGE": "שינוי",
          "MAX": "מקסימום",
          "MIN": "מינימום",
          "MID": "ממוצע",
          "SPECIAL_NOTICE": "שימו לב",
          "PRINT": "הדפסה",
          "BACK": "חזרה",
          "CLOUD_BASE": "בסיס ענן",
          "MOON_PHASE": "מצב הירח",
          "SUN_PHASE": "השמש",
          "WHOLE_SEASON": "רב שנתי",
          "TILL_NOW": "עד עכשיו",
          "DIFF_FROM": "יחסית ל",
          "NORMAL": "ממוצע",
          "DAYS": "ימים",
          "RAINY_DAYS": "ימי גשם",
          "GLOBAL_WARMING": "התחממות בי-ם",
          "DAILY_LOOP": "סרטון של כל התמונות של היום",
          "DAILY_LOOP_ARCHIVE": "איך היום נראה - לפי תאריך",
          "BY_DATE": "לפי תאריך",
          "SATELLITE": "לווין",
          "PICTURES": "אלבום תמונות",
          "DID_YOU_KNOW": "הידעת?",
          "ALBUM_DESC": "תמונות של עונות השנה, של התחנה, של פלאי טבע מרחבי העולם ועוד...",
          "WINTER": "חורף",
          "AUTOMN": "סתיו",
          "SPRING": "אביב",
          "SUMMER": "קיץ",
          "MOBILE_REDIRECT": "לדף מותאם לנייד",
          "DESKTOP_REDIRECT": "לאתר הכללי",
          "STAY": "השאר באתר המלא",
          "RUNNING_TREKS": "מסלולי ריצה",
          "FSEASON": "מהי העונה החביבה עליך?",
          "LIVE_PICTURE": "שידור חי",
          "PIC_DESC": "שתי מצלמות ואנימציה של תמונות אחרונות",
          "LIVE_STREAM": "סרט חי",
          "CAMERA": "מצלמה",
          "CAMERA_LOOP": "תמונות אחרונות באנימציה",
          "TRENDS": "מגמות",
          "DAYS_WITHOUT_RAIN": "ימים ללא גשם",
          "LEFTOVER": "עודף של",
          "LACK": "חסרים",
          "COLD_METER": "לא מסכימים? הצביעו!",
          "COLD_METER_YES": "כן, רוצה לחזק",
          "WEATHER_CLIPS": "סרטוני מזג-אוויר",
          "ROAD": "בכביש",
          "ROAD_EXP": "המד מונח על אבן. אספלט עשוי להיות חם יותר בשמש",
          "ROAD_EXP_NIGHT": "בלילה זו הטמפרטורה בעין כרם, עמק המצלבה או הצבאים",
          "DEW_DESC": "18 - סאונה רמה 1 20 - סאונה רמה 2 22 - סאונה רמה 3 ",
          "VALLEY": "בעמק",
          "LOW_VALLEY": "בנקודה הנמוכה",
          "MOUNTAIN": "בהר",
          "NOT_MOUNTAIN": "לא בהר",
          "MOUNTAIN_VALLEY_DIF": "הבדל בין הר לעמק",
          "DETAILED_BY_DAY": "פירוט לפי ימים",
          "EXTREME_HEAT_INDEX": "עומס חום קיצוני",
          "HEAVY_HEAT_INDEX": "עומס חום כבד",
          "MEDIUM_HEAT_INDEX": "עומס חום בינוני",
          "LOW_HEAT_INDEX": "עומס חום קל",
          "VVHOT": "רותח, חם אש-תנור",
          "VHOT": "חם מאד, לא היסטרי",
          "HOT": "חום של לבוש קצר",
          "LHOT": "חום של טישרט",
          "NHOTNCOLD": "לא חם ולא קר",
          "COLDISH": "קריר, ג'קט קל כזה",
          "LCOLD": "קור מורגש בקטנה",
          "COLD": "קור של מעיל",
          "VCOLD": "קור ברמה של כפפות",
          "VVCOLD": " קור של ש** ",
          "HOT_GROUND": "קרקע רותחת",
          "GENDER": "מגדר",
          "MALE": "גבר",
          "FEMALE": "אישה",
          "NOR_MALE_NOR_FEMALE": "אחר, נייטרלי",
          "GENDER_NOTICE": "מדד הקור במחשב זה נגזר מהיותך",
          "GENDER_NOTICE2": " אפשר לשנות את זה בהצבעה הבאה.",
          "SHORTS": "לבוש קצר. מכנסיים וחולצה קצרים. סנדלים, כפכפים ודומיהם",
          "TSHIRT": "טישרט",
          "LONGSLEEVES": "שכבה דקה, ארוכה או קצרה, תלוי במשתמש, אפשר גם לשלב",
          "SUN_SHADE_CLOTH": "בשמש קצר, בצל ארוך",
          "SUN_SHADE_JACKET": "בשמש פתוח או להוריד, בצל קר",
          "SWEATSHIRT": "חולצה ארוכה עבה",
          "SWEATER": "סוודר או משהו חם",
          "JACKET": "ג'קט או פליז",
          "COAT": "מעיל",
          "RAINCOAT": "מעיל גשם",
          "LIGHTCOAT": "מעיל דק",
          "LIGHTJACKET": "ג'קט דק קליל",
          "LAYERS_BELOW": "שכבה אחת מתחת",
          "LAYERS_BELOW2": "שתי שכבות מתחת וגם גרביונים",
          "LAYERS_BELOW3": "3 שכבות מתחת, צעיף או כובע וגם גרביונים או גרביים עבים",
          "LAYERS_BELOW3_PLUS": "3 שכבות מתחת, צעיף וכובע וגם גרביונים או גרביים עבים, ביגוד תרמי וגטקס",
          "UMBRELLA": "מטריה",
          "NOTHING_SPECIAL": "שום דבר מיוחד",
          "HIGH_DEW_OVER_NIGHT": "הרבה טל במהלך הלילה - דשא רטוב",
          "RAIN_WILL_STOP": "הגשם ייפסק",
          "MORE_CLOUDS": "העננים ייתרבו",
          "RAIN_HAS_JUST_STOPPED": "הפוגה בגשם",
          "RAIN_HAS_GONE": "הפוגה בגשם",
          "ITS_RAINING": "יורד גשם",
          "STORMY": "גשום וסוער",
          "ITS_SNOWING": "יורד שלג",
          "RAIN_PROB_EXP_TITLE": "הסבר על אחוזי גשם",
          "RAIN_PROB_EXP": "סיכוי נמוך (30%) - לקיים אירוע בחוץ תוך מודעות למצב שיירד גשם (תכנית גיבוי). \r\nסיכוי בינוני-טוב (50%-60%) - לקיים אירוע בחוץ שלא רגיש לגשם וניתן לעשות הפסקות קצרות תחת מחסה או\r\nפשוט להיות עם מטרייה\\מעיל גשם. \r\n\r\nסיכוי גבוה (80%) - לא מתאים לפעילות רציפה בחוץ. אבל מה הבעיה בעצם להיות עם מעיל גשם או מטרייה?",
          "RAIN_LOW_EXP": "סיכוי נמוך (30%) - לקיים אירוע בחוץ תוך מודעות למצב שיירד גשם (תכנית גיבוי). \r\n",
          "RAIN_GOOD_EXP": "\r\nסיכוי בינוני-טוב (50%-60%) - לקיים אירוע בחוץ שלא רגיש לגשם וניתן לעשות הפסקות קצרות תחת מחסה או\r\nפשוט להיות עם מטרייה",
          "RAIN_HIGH_EXP": "סיכוי גבוה (80%) - לא מתאים לפעילות רציפה בחוץ. אבל מה הבעיה בעצם להיות עם מעיל גשם או מטרייה?",
          "PRESSURE_IS_FALLING": "הלחץ יורד",
          "DRASTIC_TEMP_DROP": "התקררות",
          "DRASTIC_PRESSURE_RISE": "עלייה בלחץ",
          "DRASTIC_TEMP_RISE": "התחממות",
          "DRASTIC_WIND_RISE": "הרוח מתחזקת",
          "VERY_DRY": "יבש מאד",
          "DRASTIC_HUM_RISE": "עלייה בלחות",
          "DRASTIC_HUM_DROP": "התייבשות",
          "HIGH_DUST": "האוויר מאובק",
          "WINDY": "רוחות חזקות",
          "WIND_GUST": "משב",
          "WIND_SHIFT": "חיגה ברוח",
          "NO_WIND": "האוויר עומד",
          "WITHOUT_WIND": "ללא רוח",
          "LIGHT_WIND": "רוח קלה",
          "MODERATE_WIND": "רוח ערה",
          "VERY_HOT_HEAT_WAVE": "שרבי",
          "WARMER_THAN_AVERAGE": "חם מהרגיל",
          "COLDER_THAN_AVERAGE": "קר מהרגיל",
          "HIGH_HUMIDITY": "לחות מורגשת בספורט",
          "SAUNA1": "דביק בקיפול של היד",
          "SAUNA2": "סאונה ברמה של דביק בעפעפים",
          "SAUNA3": "סאונה רמה 3 - להזמין אינסטלטור",
          "LIKE_AVERAGE": "כמו הממוצע",
          "THERE_IS": "יש",
          "RAIN_SITUATION": "מצב הגשמים",
          "YOU_BETTER": "כדאי",
          "CLOSE": "לסגור",
          "OPEN": "לפתוח",
          "THE_WINDOW": "חלון",
          "OUTSIDE": "בחוץ",
          "INSIDE": "בפנים",
          "VERY_COLD": "קור שלא פוגשים כל יום",
          "COLD_SUN": "שמש שלא תעבור פוליגרף",
          "HALF_COLD_SUN": "שמש בשקר לבן",
          "SHADE": "בַּצֵּל",
          "SUN_SHADE": "סהרה בשמש, סיביר או קריר בצל",
          "GOOD_TIME": [
              "Good time to stay outside",
              " טוב לשבת בחוץ ולקשקש",
              "Советуем выйти сегодня из дома",
              "sympa de rester papoter dehors"
          ],
          "GOOD_TIME_FOR": "זמן טוב ל",
          "NOT_GOOD_TIME_FOR": "לא זמן טוב ל",
          "GOOD_DAY_FOR": "יום טוב ל",
          "GOOD_LAUNDRY": "זמן טוב לייבש את הכביסה",
          "SOSO_LAUNDRY": "לא תנאים אידיאליים לכביסה, אבל אפשרי",
          "BAD_LAUNDRY": "זמן רע לייבוש כביסה בגלל גשם, אבק או לחות",
          "IN": "בעוד",
          "REMOVE_LAUNDRY": "כדאי להוריד את הכביסה",
          "PIVOT_DESC": "המטרה של הדף הזה היא למזג את הבית כך שייתקרב כמה שיותר לתחושה הנוחה ביותר לנו. זה כמובן אינדיבידואלי, לכן צריך לעשות כמה הנחות. ההנחה היא שהטמפרטורה האידיאלית בבית היא: ",
          "RECORDS_LINK": "מתי ירדו 1134 מ''מ ? הכנסו לכאן",
          "YEARLY_SUMMARY_LINK": "מה קרה בכל חודש? חפשו בסיכום השנתי",
          "MONTHLY_SUMMARY_LINK": "מה היה בכל יום ויום? הכנסו לסיכום החודשי",
          "KINNERET": "מפלס הכנרת",
          "NEW": "חדש",
          "LAST_RECORD": "שיא קודם",
          "ON": "ב-",
          "YEARLY": "שנתי",
          "BROKEN": "נשבר",
          "RECORD": "שיא",
          "RECORDS": "שיאים",
          "REPORTS": "דוחות",
          "HIGH": "גבוה",
          "LOW": "נמוך",
          "AVERAGE": "ממוצע",
          "YEARLY_AVERAGE": "ממוצע שנתי",
          "MONTH": "חודש",
          "YEAR": "שנה",
          "MONTHS": "חודשים",
          "MONTHLY": "חודשי",
          "DAY": "יום",
          "DAILY_RAIN": "גשם היום מחצות",
          "STORM_RAIN": "גשם במערכת",
          "TOTAL_RAIN": "סה''כ עונתי",
          "MONTHLY_RAIN": "גשם החודש",
          "SHOW": "הצג",
          "SEND": "שליחה",
          "CANCEL": "ביטול",
          "MORE_INFO_SPAN": "מפורט יותר",
          "ALL_GRAPHS": "כל הגרפים שיש",
          "MORE_THAN": "יותר מ-",
          "LESS_THAN": "פחות מ-",
          "GRAPH": "גרף",
          "FOR": "ל-",
          "WEEKS": "שבועות",
          "HISTORY": "היסטוריה",
          "WHAT_HAPPEND": "מה היה",
          "HAPPENING": "מה עכשיו",
          "WILL_HAPPEN": "תחזית",
          "MY": "אישי",
          "GENERAL": "כללי",
          "CURRENT_INSTABLITY": "אי יציבות כרגע",
          "MEDIUM": "בינוני",
          "EXTREME": "קיצוני",
          "WEAK": "חלש",
          "STRONG": "חזק",
          "INVERSION": "אינברסיה",
          "RADIOSONDE": "רדיוסונדה",
          "FIRE_INDEX": "סכנה גבוהה בהצתת שריפות",
          "DELTA": "חוזק אינברסיה",
          "THICKNESS": "עובי אינברסיה",
          "BASE": "בסיס אינברסיה",
          "LEGEND": "מקרא",
          "SOURCE": "מקור",
          "IMS": "השירות המטאורולוגי",
          "MY_STATION": "התחנה שלי",
          "RAIN_SEASONS": "עונות גשם",
          "RAINRATE": "עוצמת גשם",
          "DEW": "נקודת טל",
          "THSW": "שקלול הרוח הלחות והקרינה",
          "AIR_DENSITY": "צפיפות האוויר",
          "AIR_QUALITY": "מה מצב זיהום האוויר?",
          "HEAT_IDX": "עומס חום",
          "WIND_SPEED": "מהירות רוח",
          "WIND_DIR": "כיוון רוח",
          "WIND_HIGH": "משבים",
          "WIND_HIGH_DIR": "כיוון משבים",
          "WIND_RUN": "הספק רוח",
          "FULL": "מלא",
          "NEW_MOON": "הירח ריק",
          "FULL_MOON": "הירח מלא",
          "MOON": "הירח",
          "RISE": "זריחה",
          "SET": "שקיעה",
          "SEARCH_IN": "חפש",
          "BETWEEN": "בין",
          "CHAT_TITLE": "פורום",
          "SYNOP_TITLE": "סינופטיקה",
          "MESSAGES": "עדכונים",
          "CURRENT_STORY": "הסיפור השבועי",
          "PRIVATE_MSG": "הודעה פרטית",
          "PRIVATE_MSG_TO_SENDER": "הודעה פרטית לפותח השרשור",
          "ALERT_MSG_TO_SENDER": "קבלת התראה על תגובה",
          "MANAGER": "מנהל ירושמיים",
          "V_MANAGER": "סגן מנהל",
          "NAME": "שם",
          "BODY": "הודעה",
          "WATCH": "צפייה ב-",
          "REPLY": "תגובה",
          "REPLYES": "תגובות",
          "NEED_TO_REGISTER": "צריך להירשם או להיכנס מחדש",
          "ALERTS_PAYMENT_FULL": "       רוצה לקבל את זה לפני כולם? כאן\"התראות<\/a><\/div>",
          "ALERTS_TO_APP_PROMO": "את כל הטוב הזה אפשר לקבל לפני כולם בהודעת פוש באפליקציה",
          "ALERTS_PAYMENT": "<div class=\"alertspayment\"><a href=\"#opensettings.png\"><img src=\"images\/opensettings.png\" alt=\"התראות טווח קצר\" width=\"18\" \/><\/a><\/div>",
          "SHORT_TERM_DESC": "את הקוד מכניסים בתוך תפריט ההגדרות של האפליקציה. הקוד שלך למינוי התראותלטווח קצר מאפליקציית ירושמיים",
          "SHORT_TERM_TITLE": "התראות לטווח קצר - ירושמיים",
          "PATREON_LINK": "<a href=\"https:\/\/www.patreon.com\/bePatron?c=1347814&rid=2162701\" target=\"_blank\">כאן!<\/a>",
          "REPLY_EXP": "לחץ כאן ולאחר מכן על שליחה",
          "REPLY_ENGAGE": "תגובותיתקבלו בשמחה על כל נושא",
          "FILTERRING_BY_SUBJECT": "סינון לפי נושאים",
          "MSG_SUBJECT": "נושא ההודעה",
          "LAST_MSG": "הודעות אחרונות",
          "LAST_DAY": "יום אחרון",
          "LAST_WEEK": "שבוע אחרון",
          "LAST_MONTH": "חודש אחרון",
          "WATCH_ALL": "צפייה בכל ההודעות",
          "MAN_EXP": " הודעות מהנהלת האתר מסומנות באדום, על כל שאר ההודעות אין אחריות.<\/li>      תעברו על התחזית לטווח קצר והתחזית לטווח בינוני ואם אין מענה לשאלתכם - פרסמו שאלה.<\/li>       הפורום לא נועד להשוואות עם תחזיות של אתרים אחרים. זה לא המקום.<\/li>       להודעות כפולות שכבר קיימות בלוח לא תנתן תשובה.<\/li>       תגובות שאינן קשורות להודעה המקורית תמחקנה. נא להוסיף הודעות או תגובות במקום המתאים להן.<\/li>       זה לא וואטסאפפ. תגובות כמו חחחח, וואלה, מדהים לא מתאימות. תכניסו תוכן אמתי שמקדם את הפורום.<\/li>",
          "CHECK_EMAIL": "כעת יש לגשת לאימייל שלך כדי לאשר את הוספתך למערכת. אם לא רואים שום דבר, לבדוק בדואר זבל",
          "USER_ID_EXP": "שם משתמש באנגלית, אפשר עם מספרים - לשימוש עתידי",
          "DISPLAY_NAME_EXP": "השם שיוצג בהודעות",
          "NICENAME_EXP": "השם הרשמי שיוצג במייל או בהפניה רשמית",
          "PERSONAL_COLD_METER_EXP": "מדד הקור יוצג בהתאם להצבעות שלך בלבד",
          "HELLO": "שלום",
          "HOTORCOLD_Q": "איך ההרגשה עכשיו עם הטמפרטורה הנוכחית בַּצֵּל?",
          "HOTORCOLD_T": "מדד הקור",
          "FSEASON_T": "העונה הכי טובה",
          "ONLYONEVOTE": "מאז שהצבעת בפעם האחרונה לא חלף מספיק זמן",
          "TOTAL_VOTERS": "סה''כ מצביעים",
          "TOTAL_VOTERS_FEMALE": "סה''כ מצביעות",
          "MOST_POPULAR": "הכי פופולרי",
          "HAPPY": "שמח",
          "ANGRY": "כועס",
          "TIRE": "עייף",
          "EMBARRASED": "נבוך",
          "SAD": "עצוב",
          "SATISFIED": "מרוצה",
          "IMHOT": "חם לי",
          "IMCOLD": "קר לי",
          "DOUBT": "סקפטי",
          "WINK": "קריצה",
          "AMAZED": "נדהם",
          "CONFUSE": "מבולבל",
          "KISS": "נשיקה",
          "COOL": "רגוע",
          "CURIOUS": "סקרן",
          "DIGGING": "יא חופרים",
          "PUDENCY": "ביישן או צנוע",
          "HELL": "מי יכול עלי",
          "RUN_WALK": "הליכה וריצה",
          "HUM_LOW": "לחות נמוכה",
          "HUM_HIGH": "לחות גבוהה",
          "HUM_NEUTRAL": "לחות נייטרלית",
          "RUN_GENERAL_EXP": "בהליכה ובריצה דרוש פחות ביגוד. בעיקרון שכבה אחת פחות בהליכה ושתיים פחות בריצה. בתנאים רגילים, טמפרטורה דו-ספרתית מאפשרת ריצה עם קצר (פחות מ-15 לכיוון 10 לשקול ארוך, במיוחד אם הפעילות לא ארוכה). חד ספרתית דורשת ארוך עם אביזר חימום כמו כפפות, כובע ומגן- אוזניים. תמיד עדיף אביזר חימום על פני עוד חולצה כי מהחלקים החשופים בורח החום.",
          "WIND_HUM_EXP": "לחות מחממת - רוח מקררת",
          "SUN_EXP": "שהות בשמש תמיד מחממת. לעתים רק בכמה מעלות ולעתים ביותר מ-10 מעלות.",
          "HIGH_WIND_HIGH_TEMP_EXP": "הרוח מצננת את השמש הלוהטת",
          "HIGH_WIND_EXP": "רוח חזקה - קחו עוד שכבה",
          "LIGHT_WIND_NIGHT_EXP": "הרוח נותנת תחושה קרירה יותר",
          "NO_WIND_LOW_TEMP_EXP": "אין רוח - תנאים טובים",
          "HIGH_HUM_EXP": "הלחות נותנת הרגשה חמה יותר, מזיעים יותר",
          "LOW_HUM_LOW_TEMP_EXP": "הלחות נותנת תחושה קרה, אולי כדאי להוסיף שכבה",
          "LOW_HUM_HIGH_TEMP_EXP": "לחות נמוכה,קלאסי, שתו יותר",
          "SUN_SHADE_DIFF_EXP": "בשמש חם הרבה יותר",
          "DID_YOU_KNOW_EX": [
              "מדד קור מותאם אישית. מה זה אומר? מקבלים את ההצבעות שלך (טקסט נטוי על הצד) ולא של כולם או של המגדר שלך אם הצבעת ולא נרשמת. אם בטמפרטורה מסויימת אין הצבעה שלכם - מקבלים הצבעה של כולם. מה צריך לעשות כדי לקבל את זה? להירשם",
              "הטמפרטורה הנמוכה ביותר ביממה היא לרוב ממש לפני הזריחה, בתנאי שהשמיים בהירים וללא רוח כמעט ",
              "שכבת השלג העבה ביותר בהיסטוריה של י-ם הייתה 98 סמ",
              "ההרגשה בחוץ משתנה ממקום למקום ובתלות בשמש, רוח, לחות. לכן, כדאי להביט ב`מרגיש כמו` ובמיקומים של הר ועמק כדי לקבל תמונה כוללת",
              "לחות מחממת, רוח מקררת. הלחות לא משתנה לרוב בתוך העיר, אבל הרוח חזקה יותר במקומות גבוהים חשופים למערב מאשר בעמקים",
              "הבסיס לחימום טוב של הגוף בעונה הקרה הוא בחירת נעליים מבודדות מהקרקע וגרביים תרמיים. ברגע שחם שם זה משפיע על כל הגוף.",
              "כשיוצאים צריך לחשוב לפני איזה פעילות נעשה ובהתאם לזה לבחור לבוש. אם יוצאים לפעילות אקטיבית כדאי מראש להוריד שכבה"
          ],
          "DID_YOU_KNOW_SUMMER": [
              "הטמפרטורה הגבוהה ביותר שנמדדה בירושלים היתה 44 מעלות בשנת 1881, בתאריכים ה–28 וה–30 לאוגוסט",
              " מדד קור מותאם אישית. מה זה אומר? מקבלים את ההצבעות שלך (טקסט נטוי על הצד) ולא של כולם (או של כל הגברים או הנשים בהתאם למגדר שלך). אם בטמפרטורה מסויימת אין הצבעה שלכם - מקבלים הצבעה של כולם. ",
              "ההרגשה בחוץ משתנה ממקום למקום ובתלות בשמש, רוח, לחות. לכן, כדאי להביט ב`מרגיש כמו` ובמיקומים של הר ועמק כדי לקבל תמונה כוללתהטמפרטורה הנמוכה ביותר ביממה היא לרוב ממש לפני הזריחה, בתנאי שהשמיים בהירים וללא רוח כמעט"
             
          ],
          "DUST_EXISTS_IN24HF": [
              "דאגו שהאבק שיגיע לא ייכנס לנשימה ולנשמה",
              " האבק יגבר בקרוב, סגרו חלון ",
              "כדאי לעקוב אחרי רמות האבק בשעות הקרובות"
          ],
          "RAIN_EXISTS_IN24HF": [
              "הבטחנו לכם יום גשם והרווחנו עוד יום שמש, סתם, סתם",
              "גשם בעיתו והעת מתקרבת",
              "השמיים הכחולים מחכים רק בשבילך... טעות, גשם מקסים צפו"
          ],
          "HIGHWIND_EXISTS_IN24HF": [
              "רוח חזקה צפויה בהמשך, סגרו חלון או משהו",
              "העצים יתחילו לרקוד מעוצמת הרוח",
              "טחנת הרוח סוף סוף תהיה יעילה בקרוב"
          ],
          "END": "אישור",
          "CLICK_TO_CONFIRM": "הקליקו כאן כדי לאשר הרשמה לאתר ירושמיים",
          "CLICK_TO_RESET": "כאן ירושמיים. לא נורא ששכחתם את הססמה. הקליקו כאן כדי לאפס",
          "CHECK_EMAIL_RESET_PASS": "יש לגשת אל האימייל שלך כדי לבצע איפוס ססמא",
          "PROBLEM_USER_PASSWORD": "סיסמא לא נכונה או משתמש לא קיים",
          "NO_USER_EXIST": "אין משתמש כזה",
          "VISIBILITY": "ראות",
          "SUNRISE": "זריחה",
          "SUNSET": "שקיעה",
          "CLOTH": "לבוש",
          "LAYOUT": "סידור עמוד",
          "SNOW_POEMS": "חמשירי שלג",
          "VOTE_INSERTED": "הצבעתך התקבלה! הצטרפת לאלפי מצביעים שמשפיעים על מדד הקור המוצג. תודה!"
        }
      },
    }
  });

export default i18n;